const clientSideUseError = `
Methods exposed by the \`@vsf-enterprise/redis-sdk\` module can only be used server-side.
In Next, call them e.g. within \`getServerSideProps()\` or a React Server Component.
In Nuxt, call them e.g. within \`useAsyncData()\`.
`;
/**
 * Client-side implementation of the Redis module.
 */
const redisModule = () => ({
    connector: new Proxy({}, {
        get() {
            return async () => {
                throw new Error(clientSideUseError);
            };
        },
    }),
    utils: {},
    subscribers: {},
});

export { redisModule };
//# sourceMappingURL=index.browser.es.js.map
